import type { ReactNode } from 'react';
import type { TrackingView } from '../trackingUtils';
import useMtText from './useMtText';
import './TrackingChips.scss';

export interface TrackingChip {
    key: string;
    label: string;
    onRemove: () => void;
}

export type SavedView = 'emergency' | 'alert' | 'parts';

interface ITrackingChipsProps {
    view: TrackingView;
    onViewChange: (view: TrackingView) => void;
    viewActions?: ReactNode;
    chips: TrackingChip[];
    onClearAll: () => void;
    onApplyView: (view: SavedView) => void;
}

const VIEWS: TrackingView[] = ['table', 'board', 'kanban'];
const SAVED_VIEWS: SavedView[] = ['emergency', 'alert', 'parts'];

const TrackingChips = ({ view, onViewChange, viewActions, chips, onClearAll, onApplyView }: ITrackingChipsProps) => {
    const { t } = useMtText();

    return (
        <div className='mt-chipsrow'>
            <div className='mt-viewtools'>
                <fieldset className='mt-seg' aria-label={t('views.label')}>
                    {VIEWS.map(item => (
                        <button
                            type='button'
                            key={item}
                            aria-pressed={view === item}
                            onClick={() => onViewChange(item)}
                        >
                            {t(`views.${item}`)}
                        </button>
                    ))}
                </fieldset>
                {viewActions}
            </div>

            <span className='mt-spacer' />

            <div className='mt-chipsdyn'>
                {chips.map(chip => (
                    <span key={chip.key} className='mt-chip'>
                        {chip.label}
                        <button type='button' aria-label={t('chips.remove')} onClick={chip.onRemove}>
                            ×
                        </button>
                    </span>
                ))}
                {chips.length > 0 && (
                    <>
                        <button type='button' className='mt-linkbtn' onClick={onClearAll}>
                            {t('chips.clearAll')}
                        </button>
                        <span className='mt-sep' />
                    </>
                )}
                <span className='mt-saved'>
                    <span className='mt-saved__label'>{t('savedViews.label')}</span>
                    {SAVED_VIEWS.map(item => (
                        <button type='button' key={item} className='mt-saved__item' onClick={() => onApplyView(item)}>
                            {t(`savedViews.${item}`)}
                        </button>
                    ))}
                </span>
            </div>
        </div>
    );
};

export default TrackingChips;
